import { TeamResponse } from "@herbjoy/apex-api-models";
import { IHttpService } from "angular";

export class TeamService {
    constructor(private $http: IHttpService, private apexApiUrl: string) {
        'ngInject'
    }

    retrieveTeams(query) {
        return this.$http<TeamResponse[]>({
            url: this.apexApiUrl + "teams",
            method: "GET",
            headers: { Accept: "application/json" },
            params: query
        }).then(response => {
            return response.data;
        });
    }

    retrieveTeamMembers(teamLeaderEmpId: any) {
        return this.$http({
            method: "GET",
            url: this.apexApiUrl + "teams/RetrieveTeamMembers/" + teamLeaderEmpId,
            headers: { Accept: "application/json" }
        })
            .then(function (response) {
                console.log(response.data);
                return response.data;
            })
            .catch((err) => {
                console.log(err)
            });
    }

    retrieveTeam(teamID) {
        return this.$http<TeamResponse>({
            url: this.apexApiUrl + "teams/" + teamID,
            method: "GET",
            headers: { Accept: "application/json" }
        }).then(response => {
            return response.data;
        });
    }

    createTeam(request) {
        return this.$http<TeamResponse>({
            url: this.apexApiUrl + "teams",
            method: "POST",
            headers: { Accept: "application/json", "Content-Type": "application/json" },
            data: request
        }).then(response => {
            return response.data;
        });
    }

    updateTeam(teamID, request) {
        request.TeamID = teamID;
        return this.$http<TeamResponse>({
            url: this.apexApiUrl + "teams/" + teamID,
            method: "PUT",
            headers: { Accept: "application/json", "Content-Type": "application/json" },
            data: request
        }).then(response => {
            return response.data;
        });
    }

    deleteTeam(teamID) {
        return this.$http<void>({
            url: this.apexApiUrl + "teams/" + teamID,
            method: "DELETE"
        });
    }

    addTeamMember(teamID, request) {
        return this.$http<TeamResponse>({
            url: this.apexApiUrl + "teams/" + teamID + "/team-members",
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            data: request
        }).then(response => {
            // The employee ID is returned from the response.
            return response.data;
        });
    }

    assignTeamMemberRoles(teamID, employeeID, roles, leader) {
        return this.$http<void>({
            url: this.apexApiUrl + "teams/" + teamID + "/team-members/" + employeeID,
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            data: {
                roles: roles,
                leader: leader
            }
        });
    }

    removeTeamMember(teamID, employeeID) {
        return this.$http<void>({
            url: this.apexApiUrl + "teams/" + teamID + "/team-members/" + employeeID,
            method: "DELETE"
        });
    }
}
